import React from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { Home, Sparkles, Gift, User } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import Footer from '../components/Footer';

const CustomerLayout = () => {
  const location = useLocation();
  const { user } = useAuth();

  const navItems = [
    { path: '/customer/dashboard', icon: Home, label: 'Home' },
    { path: '/customer/services', icon: Sparkles, label: 'Services' },
    { path: '/customer/rewards', icon: Gift, label: 'Rewards' },
    { path: '/customer/profile', icon: User, label: 'Profile' },
  ];

  return (
    <div className="min-h-screen bg-[#FFFFF0] flex flex-col">
      {/* Header */}
      <header className="sticky top-0 z-30 bg-white/80 backdrop-blur-lg border-b border-[#F5E6D3]">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <div>
            <h1 className="font-serif text-2xl text-[#4A154B]">Salon O</h1>
            <p className="text-xs text-[#C9A689] tracking-widest uppercase">Luxury Rewards</p>
          </div>
          {user && (
            <div className="text-right">
              <p className="text-sm text-gray-600">Welcome back,</p>
              <p className="font-medium text-[#4A154B]">{user.name || 'Guest'}</p>
            </div>
          )}
        </div>
      </header>

      {/* Main Content - with padding for both footer and bottom nav */}
      <main className="flex-1 pb-40">
        <Outlet />
      </main>

      {/* Footer - positioned above bottom nav with proper spacing */}
      <div className="pb-20">
        <Footer variant="light" />
      </div>

      {/* Bottom Navigation */}
      <nav className="bottom-nav">
        {navItems.map(({ path, icon: Icon, label }) => (
          <NavLink
            key={path}
            to={path}
            className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
            data-testid={`nav-${label.toLowerCase()}`}
          >
            <Icon size={22} strokeWidth={1.5} />
            <span className="text-xs font-medium">{label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
};

export default CustomerLayout;
